import {POST} from 'helpers/services/constants/API_CONSTANTS';
import {API_CREATE_BANK_ACCOUNT_UPDATE_LINK} from 'helpers/services/constants/API_ENDPOINTS';
import {request} from 'helpers/services/utils/request';

// eslint-disable-next-line import/prefer-default-export
export const createBankAccountUpdateLinkApi = async (locationId) => {
  return request(POST, API_CREATE_BANK_ACCOUNT_UPDATE_LINK(locationId), null, {
    silent: true
  });
};
